<template>
  <div class="tipdia">
    <el-dialog
      :title="title === 1 ? '取消订单' : '确认交易'"
      :visible.sync="tipdia"
      width="40%"
      top="6vh"
      :before-close="handleClose"
    >
      <div style="height:220px">
        <div v-if="title === 1" class="tipTest">
          是否取消订单：{{ selectOrder.forderNo }}<img style="width:80px;height:50px;vertical-align: middle;" src="@/assets/images/remove-err.png" alt="">
        </div>
        <div v-if="title === 2">
          <div class="tiptest2">
            <div style="display:flex;">
              <div>
                <img style="width:30px;height:30px;vertical-align: middle;margin-right: 10px;" src="../../../../../assets/images/radio.png" alt="">
              </div>
              <div>
                <div>
                  当前可用额度：￥{{ paymentTypeList[0].availableAmount }}
                </div>
                <div>
                  您的付款日：每月15号 法定节假日可顺延
                </div>
              </div>
            </div>

            <div style="color:#6ca5eb;">
              温馨提示：请核对订单无误后，再确认！
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="close-btn" @click="handleClose">取 消</el-button>
        <el-button class="confirm-btn" type="primary" @click="comfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cancelOrder, confirmOrder, queryReceivingAddr } from '@/api/order.js'
export default {
  props: {
    tipdia: {
      type: Boolean
    },
    title: {
      type: Number,
      default: () => 1
    },
    selectOrder: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      paymentTypeList: [{
        availableAmount: ''
      }]
    }
  },
  watch: {
    tipdia(val) {
      if (val || this.title === 2) {
        queryReceivingAddr()
          .then(res => {
            console.log(res)
            this.paymentTypeList = res.data.paymentTypeList
          })
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeTip')
    },
    comfirm() {
      if (this.title === 1) {
        const params = new URLSearchParams()
        params.append('id', this.selectOrder.fid)
        cancelOrder(params)
          .then(res => {
            if (res.result) {
              this.$message.success(res.msg)
              this.handleClose()
              this.$emit('onSearch')
            } else {
              this.$message.error(res.msg)
            }
          })
      } else {
        const arr = [{
          fno: this.selectOrder.fid
        }]
        const params = new URLSearchParams()
        params.append('jsonobj', JSON.stringify({ fnoList: arr }))
        confirmOrder(params)
          .then(res => {
            if (res.result) {
              this.$message.success(res.msg)
              this.handleClose()
              this.$emit('onSearch')
            } else {
              this.$message.error(res.msg)
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
.tipdia {
    .el-dialog {
        // top: 6vh;
    }
    .el-dialog__body {
        min-height: 230px;
        padding: 0px 0px 0;
        .tipTest {
            position: absolute;
            top: 50%;
            transform: translate(0,-50%);
            width: 100%;
            font-size: 18px;
            text-align: center;
        }
        .tiptest2 {
            width: 80%;
            margin: 0 10%;
            position: absolute;
            top: 50%;
            transform: translate(0,-58%);
            font-size: 18px;
            color: #EC212D;
            div {
                line-height: 50px;
                // margin-bottom: 20px;
            }
        }
    }
    .el-dialog__header {
        text-align: center;
        background: #EC212D;
        .el-dialog__title {
            color: #fff;
        }
    }
    .el-dialog__footer {
        text-align: center;
    }
    .el-form-item__label {
        width: 90px !important;
    }
    .el-form-item__content {
        margin-left: 90px !important;
    }
    .dialog-footer {
        text-align: center;
        .confirm-btn {
            width: 135px;
            height: 30px;
            line-height: 6px;
            background: #EC212D;
        }
        .close-btn {
            width: 135px;
            height: 30px;
            line-height: 6px;
            border: 1px solid #EC212D;
            color: #EC212D;
        }
    }
}
</style>
